import React from 'react';
import { Global, css } from '@emotion/react';

const style = css`
	html,
	body,
	#root {
		width: 100%;
		height: 100%;
		font-size: 16px;
	}
`;

export const GlobalStyle = () => {
	return <Global styles={style} />;
};
